import type { EbookDocument, EbookQuestion } from '@wx-weiqi/contracts';

export function parseEbookPages(value: string, pageCount: number): number[] {
  if (!value.trim()) throw new Error('请输入页码，例如 4-8,12,16');
  const indexes = new Set<number>();
  for (const part of value.replaceAll('，', ',').split(',')) {
    const match = /^\s*(\d+)(?:\s*-\s*(\d+))?\s*$/.exec(part);
    if (!match) throw new Error('页码格式为 4-8,12,16');
    const from = Number(match[1]),
      to = Number(match[2] ?? from);
    if (from < 1 || to < from || to > pageCount) throw new Error('页码超出这份 PDF 的范围');
    for (let page = from; page <= to; page++) indexes.add(page - 1);
  }
  return [...indexes].sort((a, b) => a - b);
}

// Page results contain the candidate IDs of the latest completed attempt only.
// Historical questions remain in the workspace/library and published snapshots.
export function latestEbookQuestions(pages: EbookDocument['pages'], questions: EbookQuestion[]) {
  const byCandidate = new Map<string, EbookQuestion>();
  for (const q of questions)
    if (q.candidateId && !byCandidate.has(q.candidateId)) byCandidate.set(q.candidateId, q);
  return [...pages]
    .sort((a, b) => a.index - b.index)
    .flatMap((page) =>
      page.status === 'DONE'
        ? (page.result?.candidates ?? []).flatMap((candidate) => {
            const question = byCandidate.get(candidate.id);
            return question?.source?.pageIndex === page.index ? [question] : [];
          })
        : [],
    );
}
